import React from "react";

function BlogDescreption() {
  return (
    <div className="py-8 w-[85%] md:w-[60%] mx-10 text-left font-saira">
      <p className="text-white text-4xl sm:text-5xl md:text-6xl">
        <span className="text-yellow-400"> Strength, Sweat, Success:</span>
        Your Fitness Journey Starts Here
      </p>
    </div>
  );
}

export default BlogDescreption;
